import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { installTelemetrySink, logger } from './app/core/telemetry/logger';

// Sentry (with replay) is loaded as its own chunk so it stays out of the initial
// bundle. Until it arrives, the logger writes to the console only; the user and
// facility context set in the meantime are applied when the sink installs.
void import('./app/core/telemetry/sentry-sink')
  .then(({ createSentrySink }) => {
    const sink = createSentrySink();
    if (sink) {
      installTelemetrySink(sink);
    }
  })
  .catch((err) => console.warn('[Synexa] Telemetry failed to load', err));

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => logger.error('App bootstrap failed', err));
